import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';

/*
  we are using same api glBalance to get modes and daily section totals
  in both totals 'X' -> appr daily section is of no use
*/

const isDisplaySectionOD = (record) => record._dailySection === 'OFFICIALDEPOSITORY';
const isDisplaySectionCollections = (record) => record._dailySection === 'COLLECTIONS';
const isDisplaySectionPayments = (record) => record._dailySection === 'PAYMENTS';
const isDisplaySectionDepositsOrChecks = (record) => record._dailySection === 'DEPOSITSANDCHECKS';
const isDisplaySectionJournalEntries = (record) => record._dailySection === 'JOURNALENTRIES';
const isDisplaySectionTransfers = (record) => record._dailySection === 'TRANSFERS';
const isDisplaySectionApportionment = (record) => record._dailySection === 'APPORTIONMENT';

export const calcTotalBalanceByDailySections = (records) => {
  const totalBalance = {
    funds: {
      OD: 0.0,
      collections: 0.0,
      warrants: 0.0,
      journalEntries: 0.0,
      transfers: 0.0,
      apportionment: 0.0,
      transferInOrOut: 0.0,
    },
    banks: {
      OD: 0.0,
      deposits: 0.0,
      checks: 0.0,
      journalEntries: 0.0,
      transfers: 0.0,
      apportionment: 0.0,
      transferInOrOut: 0.0,
    },
  };
  for (const record of records) {
    if (record._fund) {
      if (isDisplaySectionOD(record)) {
        totalBalance.funds.OD += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionCollections(record)) {
        totalBalance.funds.collections += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionPayments(record)) {
        totalBalance.funds.warrants += record.totalPayments;
      }
      if (isDisplaySectionJournalEntries(record)) {
        totalBalance.funds.journalEntries += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionTransfers(record)) {
        totalBalance.funds.transfers += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionApportionment(record)) {
        totalBalance.funds.apportionment += (record.totalTransferIn)
          - (record.totalTransferOut);
      }
    }
    if (record._bank) {
      if (isDisplaySectionOD(record)) {
        totalBalance.banks.OD += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionDepositsOrChecks(record)) {
        totalBalance.banks.deposits += record.totalDeposit;
        totalBalance.banks.checks += record.totalPayments;
        totalBalance.banks.transferInOrOut += (record.totalTransferIn - record.totalTransferOut);
      }
      if (isDisplaySectionJournalEntries(record)) {
        totalBalance.banks.journalEntries += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionTransfers(record)) {
        totalBalance.banks.transfers += (record.totalDeposit + record.totalTransferIn)
          - (record.totalTransferOut + record.totalPayments);
      }
      if (isDisplaySectionApportionment(record)) {
        totalBalance.funds.apportionment += (record.totalTransferIn)
          - (record.totalTransferOut);
      }
    }
  }
  return totalBalance;
};

export const calTotalModesBalance = (balanceArr) => {
  const bankFundTotalModeWise = {
    fund: {
      deposit: 0.0,
      transferIn: 0.0,
      payment: 0.0,
      transferOut: 0.0,
    },
    bank: {
      deposit: 0.0,
      transferIn: 0.0,
      payment: 0.0,
      transferOut: 0.0,
    },
  };
  for (const balance of balanceArr) {
    if (balance._fund) {
      bankFundTotalModeWise.fund.deposit += balance.totalDeposit;
      bankFundTotalModeWise.fund.transferIn += balance.totalTransferIn;
      bankFundTotalModeWise.fund.payment += balance.totalPayments;
      bankFundTotalModeWise.fund.transferOut += balance.totalTransferOut;
    }
    if (balance._bank) {
      bankFundTotalModeWise.bank.deposit += balance.totalDeposit;
      bankFundTotalModeWise.bank.transferIn += balance.totalTransferIn;
      bankFundTotalModeWise.bank.payment += balance.totalPayments;
      bankFundTotalModeWise.bank.transferOut += balance.totalTransferOut;
    }
  }
  return bankFundTotalModeWise;
};

const balanceLeft = (balances) => {
  const msgArray = [];
  if (balances.OD !== 0) {
    msgArray.push(`OD Banks and Funds are out of Balance $${amountFormat(Math.abs(balances.OD))} \n`);
  }
  if (balances.DC !== 0) {
    msgArray.push(`Collections and Deposits are out of Balance $${amountFormat(Math.abs(balances.DC))} \n`);
  }
  if (balances.CA !== 0) {
    msgArray.push(`Warrants and Checks are out of Balance $${amountFormat(Math.abs(balances.CA))}.`);
  }
  if (balances.JE !== 0) {
    msgArray.push(`Out of Balance Due to Journal Entries $${amountFormat(Math.abs(balances.JE))}.`);
  }
  if (balances.T !== 0) {
    msgArray.push(`Out of Balance Due to Transfers $${amountFormat(Math.abs(balances.T))}.`);
  }
  if (balances.A !== 0) {
    msgArray.push(`Out of Balance Due to Apportionment $${amountFormat(Math.abs(balances.A))}.`);
  }
  return msgArray;
};

const getSectionBalance = ({ bank, fund }) => amountToNumber(amountFormat(bank))
- amountToNumber(amountFormat(fund));

const getDepositAndCollectionBalance = ({ deposits, collections }) => amountToNumber(amountFormat(
  deposits.deposits,
)) + amountToNumber(amountFormat(
  deposits.transferInOrOut,
)) - amountToNumber(amountFormat(collections));

const getCheckAndWarrantsBalance = ({ checks, warrants }) => amountToNumber(amountFormat(checks))
- amountToNumber(amountFormat(warrants));

export const getRemainingBalance = (funds, banks) => {
  const ODBalance = getSectionBalance({ bank: banks.OD, fund: funds.OD });
  const depositAndCollectionBalance = getDepositAndCollectionBalance({
    deposits: banks,
    collections: funds.collections,
  });
  const checkAndWarrantsBalance = getCheckAndWarrantsBalance({
    checks: banks.checks,
    warrants: funds.warrants,
  });
  const journalEntriesBalance = getSectionBalance(
    { bank: banks.journalEntries, fund: funds.journalEntries },
  );
  const transfersBalance = getSectionBalance({ bank: banks.transfers, fund: funds.transfers });
  const apportionmentBalance = getSectionBalance({
    bank: banks.apportionment, fund: funds.apportionment,
  });
  const balances = {
    OD: ODBalance,
    DC: depositAndCollectionBalance,
    CA: checkAndWarrantsBalance,
    JE: journalEntriesBalance,
    T: transfersBalance,
    A: apportionmentBalance,
  };
  const balanceLeftMsg = balanceLeft(balances);
  return balanceLeftMsg;
};
export const GL_CONSTANTS = {
  INTEREST_INCOME_SOURCE: '9008.0000',
  INVESTMENT_INTEREST_INCOME_SOURCE: '9007.0000',
};

export default {};
